module.exports = __webpack_public_path__ + "img/layout-center.ecc083a2.png";